import Vue from 'vue';

/**
 * To be used as global event bus.
 *
 * Based on:
 * https://alligator.io/vuejs/global-event-bus/
 * */
export const $eBus = new Vue();
